module.exports = __webpack_public_path__ + "img/bg_greenSkils.3fd1ae3b.png";